module.exports = __webpack_public_path__ + "static/media/screenshot(12).42ec581e.jpg";